export interface NoResultFoundPropType {
  resetSearch: () => void;
}

export interface PreviewImageContainerPropType {
  isLessThan1024: Boolean;
}

export const textConstants = {
  createForm: "Create your first form",
  nothingToShow: "Nothing to show",
  noResultsBasedOnSearch: "There are no results based on your search",
  trashEmpty: "Your trash is empty",
};
